<template>
  <base-dialog-button :isOpen="dialogOpen" @closeDialog="toggleDialog" :size="'md'"  :ariaLabel="isCreated ? $t('certificates.link_certificate') : $t('certificates.create_link_certificate')">
    <template slot="header">
      <div class="h-16 bg-secondary flex items-center justify-between text-white px-4">
        <div class="flex items-center">
          <h2 v-if="isCreated" class="font-bold ml-2">
            {{$t('certificates.link_certificate')}}
          </h2>
          <h2 v-else class="font-bold ml-2">
            {{$t('certificates.create_link_certificate')}}
          </h2>
        </div>
        <span class="cursor-pointer" @click="toggleDialog">
          <base-button-icon name="cross" size="xs" iconSize="sm" mode="secondary" />
        </span>
      </div>
    </template>
    <template slot="main">
      <div 
        class="form-wrapper p-4 overflow-x-hidden overflow-y-auto"
        style="max-height: 350px;"
        >
        <el-form
          :model="form"
          ref="ruleForm"
          :rules="rules"
        >
          <div class="lg:mb-2 pl-2">
            <span :key="t" v-for="t in header_message" class="w-full inline-block word-break-n text-secondary-600">{{ t }}</span>
            <div class="flex -mx-2 flex-col lg:flex-row mt-4">
              <div class="px-2 w-full lg:mb-0">
                <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('companies.cif')}}
                  <el-form-item prop="CIF">
                    <el-input
                      class="w-full"
                      v-model="form.CIF"
                      maxlength='50'
                      :disabled="true"
                    >
                    </el-input>
                  </el-form-item>
                </label>
              </div>
              <div class="px-2 w-full lg:mb-0">
                <span id="create-asociate-cif-nombre-cif-label" class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon v-if="!isCreated"/>{{$t('companies.companyName')}}</span>
                  <el-form-item prop="NombreCIF">
                    <el-input
                      class="w-full"
                      v-model="form.NombreCIF"
                      :disabled="isCreated"
                      maxlength='150'
                      aria-labelledby="create-asociate-cif-nombre-cif-label"
                    >
                      <template v-if="form.NombreCIF">
                        <base-clear-input-button
                          aria-label="Limpiar campo Nombre de la empresa"
                          @clear="form.NombreCIF = ''"
                        />
                      </template>
                    </el-input>
                  </el-form-item>
              </div>
            </div>
          
            <div v-if="isCreated && NombreCert !== null && SerialCert != null" class="mt-4">
              <span class="w-full inline-block word-break-n mb-4 text-secondary-600">{{ certMessage }}</span>
              <div class="flex -mx-2 flex-col lg:flex-row">
                <div class="px-2 w-full lg:mb-0">
                  <base-ro-input :label="$t('certificates.name')" :data="NombreCert"/>
                </div>
                <div class="px-2 w-full lg:mb-0">
                  <base-ro-input :label="$t('certificates.serial')" :data="SerialCert"/>
                </div>
              </div>
            </div>
          </div>
        </el-form>
      </div>
    </template>
    <template slot="footer">
        <base-button class="w-full ml-2 md:ml-0" mode="secondary-phantom-blue" :text="$t('app.cancel')" @click="toggleDialog"/>
        <base-button class="w-full" mode="secondary-phantom-blue" :text="$t('app.accept')" :loading="!isLoadedData" @click="apply('ruleForm')"/>
    </template>
  </base-dialog-button>
</template>

<script>
import BaseDialogButton from './base/BaseDialogButton.vue'

export default
{
  name: 'create-asociate-cif-to-certificate-dialog',
  components: {
    BaseDialogButton
  },
  props: {
    dialogOpen: {
      type: Boolean,
      default: false
    },
    isCreated: {
      type: Boolean,
      default: false
    },
    IdCIFEmpresa: {
      type: [Number],
      default: -1
    },
    NombreCert: {
      type: String,
      default: null,
    },
    SerialCert: {
      type: String,
      default: null,
    },
    InitialCIF: {
      type: String,
      default: null,
    },
    InitialNombreCIF: {
      type: String,
      default: null,
    },
  },
  watch: {
    // Disparador de eventos solo la primera vez que se llega a una ruta privada de navegación
    dialogOpen: function (value, oldValue) {
      if (value) {
        this.form.CIF = this.InitialCIF
        this.form.NombreCIF = this.InitialNombreCIF
      }
    },
  },
  data: function () {
    return {
      isOpen: this.dialogOpen,
      form: {
        CIF: '',
        NombreCIF: '',
      },
      rules: {
        NombreCIF: [
          { validator: this.isGenericValidation, trigger: 'blur' }
        ],
      },
      isLoadedData: false,
    }
  },
  mounted: async function () {
    this.isLoadedData = false

    this.isLoadedData = true
  },
  computed: {
    header_message () {
      const message = []
      if (this.isCreated) {
        if (this.NombreCert !== null && this.SerialCert != null) {
          message.push('Se ha encontrado una empresa con el CIF del certificado, con un certificado ya asociado.')
          message.push('¿Desea reemplazar a este certificado asociandolo a la empresa?')
        } else {
          message.push('Se ha encontrado una empresa con el CIF del certificado.')
          message.push('¿Desea asociarla a este certificado?')
        }
      } else {
        message.push('No se ha encontrado ninguna empresa con el CIF del certicado.')
        message.push('¿Desea crearla y asociarla a este certificado?')
      }
      return message
    },
    certMessage () {
      return 'Datos del certificado asociado:'
    }
  },
  methods: {
    toggleDialog: function () {
      this.isOpen = !this.isOpen
      this.$emit('toggleDialog')
      if (!this.Open) this.$emit('cleanAll')
    },
    apply: function (ruleForm) {
      this.$refs[ruleForm].validate(async valid => {
        if (valid) {
          this.isOpen = !this.isOpen
          const data = {
            isCreated: this.isCreated,
            isCertAsociated: (this.NombreCert === null && this.SerialCert === null),
            IdCIFEmpresa: this.IdCIFEmpresa,
            CIF: this.form.CIF,
            NombreCIF: this.form.NombreCIF,
          }
          this.$emit('applyDialog', data)
          this.clearForm()
        } else {
          this.doFeedback('Error al procesar los datos, revise la información')
        }
      })
    },
    clearForm () {
      this.form.CIF = ''
      this.form.NombreCIF = ''
    }
  }
}
</script>

<style lang="scss" scoped></style>
